
const API_URL = import.meta.env.VITE_API_URL || '';
export const API_BASE_URL = API_URL + '/api';

import axios from 'axios';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true // Importante para o Sanctum
});

// Interceptor para CSRF token
api.interceptors.request.use(async config => {
  await axios.get(API_URL + `/sanctum/csrf-cookie`);
  return config;
});

export const auth = {
  login: async (credentials:any) => {
    const response = await api.post("/login", credentials);
    const token = response.data.token;

    if (token) {
      localStorage.setItem("auth_token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    return response;
  },
  user: async () => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    return api.get("/user");
  },
  logout: async () => {
    const response = await api.post("/logout");
    localStorage.removeItem("auth_token");
    delete api.defaults.headers.common["Authorization"];
    return response;
  },
  register: async (data: any) => {
    const response = await api.post("/register", data);
    const token = response.data.token;

    if (token) {
      localStorage.setItem("auth_token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    return response;
  },
};

export default api;
